import { Component, OnInit, Input, ChangeDetectorRef, ViewRef, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FieldType } from "@ngx-formly/core";
import { AppStateService } from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../../../core-module/services/state/alo-aoc-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { MiscFeatureStateService } from "../../../core-module/services/state/misc-feature-state.service";


@Component({
  standalone: false,
  selector: "app-min-dim-level",
  templateUrl: "./min-dim-level.component.html",
  styleUrls: ["./min-dim-level.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinDimLevelComponent
  extends FieldType
  implements OnInit, OnDestroy
{
  @Input() field;
  column: LegacyAny = []; // Initialize to empty array to avoid template errors
  properties: LegacyAny;
  MinDimLevel: LegacyAny;
  MinDimLevelMin: LegacyAny;
  MinDimLevelMax: LegacyAny;
  MinDimLevelOption: { floor: LegacyAny; ceil: LegacyAny };
  ngModelval: LegacyAny = [];
  MinDimLevelVal: number;
  minDimLevelEnabledval: LegacyAny;
  minDimLevelDefaultColor: boolean;
  minDimdisbaled: LegacyAny;
  quickConfigvalue: boolean;
  quickConfigCustomCSS: string;
  setQuickConfig: string;
  inputError: LegacyAny = [];
  minDimLevelCreatFile: boolean;
  sliderDisabled: boolean;
  fileResponse: LegacyAny;
  isEdited: LegacyAny;
  isExternalRset: LegacyAny;
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private misc: MiscFeatureStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }
  ngOnInit() {
    this.isEdited = false;
    this.featureDefaults.getminDimLevelDefaultColor.subscribe((response) => {
      if (response) {
        this.resetDefaultminDimLevel();
      }
    });
    this.misc.getMinDimLevelData.subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.ngModelval["Enabled"] = data["Enabled"];
        this.ngModelval["MinDimLevelVal"] = data["MinDimLevelVal"];
        this.checkdfault();
      }
    });

    // Guard: Ensure field schema is loaded before accessing properties
    if (!this.field || !this.field.properties || !this.field.properties.MinDimLevel) {
      // Initialize with safe defaults to prevent template errors
      this.MinDimLevelOption = { floor: 0, ceil: 100 };
      this.MinDimLevelVal = 0;
      this.ngModelval["MinDimLevelVal"] = 0;
      return;
    }

    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.misc.minDimLevelInputError(false);
    this.MinDimLevel = this.properties.MinDimLevel;
    this.MinDimLevelMin = this.MinDimLevel.minimum;
    this.MinDimLevelMax = this.MinDimLevel.maximum;
    this.ngModelval["MinDimLevelVal"] = this.MinDimLevelVal =
      this.MinDimLevel.default;
    this.MinDimLevelOption = {
      floor: this.MinDimLevelMin,
      ceil: this.MinDimLevelMax,
    };
    if (this.properties["Enabled"]) {
      this.minDimLevelEnabledval = this.properties["Enabled"].default;
      this.ngModelval["Enabled"] = this.properties["Enabled"].default;
      this.rSetChanged(this.minDimLevelEnabledval);
    }
    this.aloAoc.getquickConfig.subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox textBoxUnit";
        this.setQuickConfig = "quickConfig";
      } else {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "MINDIMLEVEL") {
          isConfigEdited = true;
          const MINDIMLEVEL: LegacyAny = element["featureParameters"][0];
          this.addMinDimLevelLoadedFeatureReadValues(MINDIMLEVEL);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
      // Use centralized method to get feature data
      // This automatically prioritizes SaveSetData over ConfigurationData
      const minDimData = this.appState.getFeatureData('MinDimLevel');
      if (minDimData) {
        this.addMinDimLevelLoadedFeatureReadValues(minDimData);
      }
    }

    this.sendMinDimLeveldata(this.ngModelval);
    this.isEdited = true;
  }
  sendMinDimLeveldata(val) {
    this.misc.sendMinDimLeveldata(val);
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "MinDimLevel");
    }
  }
  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const touchDimObj = Object.assign({}, value);
    this.appState.setFeatureData(keyVal, touchDimObj);
  }
  addMinDimLevelLoadedFeatureReadValues(MinDimLevel: LegacyAny) {
    const MinDimLevelObj = MinDimLevel;
    const keys = Object.keys(MinDimLevelObj);
    const values = Object.values(MinDimLevelObj);
    keys.forEach((key, i) => {
      if (key === 'MinDimLevel') {
        this.textValChanged(values[i], 'MinDimLevelVal')
      }
    });
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.sliderDisabled = result["Enabled"] ? false : true;
    this.ngModelval["Enabled"] = this.minDimLevelEnabledval = result["Enabled"];
    this.ngModelval["MinDimLevelVal"] = this.MinDimLevelVal = result[
      "MinDimLevel"
      ]
      ? result["MinDimLevel"]
      : result["MinDimLevelVal"];
    this.checkdfault();
    this.sendMinDimLeveldata(this.ngModelval);
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  resetDefaultminDimLevel() {
    if (
      this.properties &&
      this.properties["Enabled"] &&
      this.properties["Enabled"].default
    ) {
      this.ngModelval["Enabled"] = this.minDimLevelEnabledval =
        this.properties["Enabled"].default;
    }
    if (this.properties.MinDimLevel) {
      this.ngModelval["MinDimLevelVal"] = this.MinDimLevelVal =
        this.properties.MinDimLevel.default;
    }
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.minDimdisbaled = false;
    this.sliderDisabled = false;
    this.minDimLevelCreatFile = false;
    this.minDimLevelDefaultColor = true;
    this.misc.minDimLevelInputError(this.minDimLevelCreatFile);
    this.misc.MinDimLevelEditedVal(this.minDimLevelDefaultColor);
    this.sendMinDimLeveldata(this.ngModelval);
    this.ref.markForCheck()
  }
  sliderEvent(option?) {
    this.checkdfault();
  }
  minDimLevelSlideValuechange(value) {
    this.inputError["MinDimLevelVal"] = false;
    if (
      value >= this.MinDimLevelVal &&
      this.inputError["MinDimLevelVal"] === false
    ) {
      this.ngModelval["MinDimLevelVal"] = value;
      this.sendMinDimLeveldata(this.ngModelval);
      this.checkdfault();
    }
    this.minDimLevelCreatFile = false;
    if (value < this.MinDimLevelMin || value > this.MinDimLevelMax) {
      this.inputError['MinDimLevelVal'] = true;
      this.minDimLevelCreatFile = true;
    }

    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.minDimLevelCreatFile = true;
      }
    }
    this.misc.minDimLevelInputError(this.minDimLevelCreatFile);
  }
  textValChanged(value, colName) {
    value = parseInt(value);
    if (isNaN(value)) {
      value = 0;
    }
    this.minDimLevelDefaultColor = false;
    this.inputError[colName] = false;
    this.minDimLevelCreatFile = false;
    if (value < this.MinDimLevelMin || value > this.MinDimLevelMax) {
      this.inputError[colName] = true;
      this.minDimLevelCreatFile = true;
    } else {
      this.MinDimLevelVal = value;
    }
    this.checkdfault();
    for (const type in this.inputError) {
      if (this.inputError[type]) {
        this.minDimLevelCreatFile = true;
      }
    }
    this.misc.MinDimLevelEditedVal(this.minDimLevelDefaultColor);
    this.misc.minDimLevelInputError(this.minDimLevelCreatFile);
    this.sendMinDimLeveldata(this.ngModelval);
  }
  checkdfault() {
    let newtype;
    this.minDimLevelDefaultColor = true;
    for (const type in this.ngModelval) {
      newtype = type.replace("Val", "");
      if (this.properties && this.properties[newtype] && this.properties[newtype]["default"] != null && this.ngModelval[type] != this.properties[newtype]["default"]) {
        this.minDimLevelDefaultColor = false;
      }
      this.misc.MinDimLevelEditedVal(this.minDimLevelDefaultColor);
    }
  }
  rSetChanged(val) {
    this.minDimLevelDefaultColor = val;
    for (let i = 0; i < this.column.length; i++) {
      const type = this.column[i];
      if (this.ngModelval[type] != this.properties[type]["default"]) {
        this.minDimLevelDefaultColor = false;
      }
    }

    this.checkdfault();
    this.minDimdisbaled = !val;
    this.sliderDisabled = !val;
    this.misc.MinDimLevelEditedVal(this.minDimLevelDefaultColor);
    this.sendMinDimLeveldata(this.ngModelval);
  }
  ngOnDestroy() {
    this.featureDefaults.setMinDimLevelDefaultColor("");
  }
}
